import {
  AccordionSummary,
  Box,
  CircularProgress,
  Grid,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import messages from 'components/Refunds/messages';
import { StyledCaption, StyledShortBody } from 'components/Refunds/styles';
import StatusChip from 'components/StatusChip';
import { ShortBody } from 'components/Typography';
import { SINISTER_DOCUMENT_TYPES } from 'constants/globalConstants';
import { StyledAccordionDetails } from 'containers/AmcDetailsPage/MyRefundsTab/Refunds/styles';
import { FEATURES } from 'features/features';
import FeatureToggleHOC from 'features/FeatureToggleHOC';
import { translate } from 'helpers/intl';
import { get, isEmpty } from 'lodash';
import React from 'react';
import { injectIntl, IntlShape, useIntl } from 'react-intl';
import { getDecompOrganismesApi } from 'store/user/apis';
import { AssuranceIcon } from 'images';
import { DocumentParams, RefundDetails } from '.';
import ClaimButton from './ClaimButton';

interface ValidatedClaimType {
  intl: IntlShape;
  refund: {
    statusApplication: String;
    maladyDeclarationSuffix: String;
    numeroPolicy: string;
    numeroApplication: Number;
    beneficiary: String;
    dateNum: Number;
    years: Number;
    dateOccu: string;
  };
  refundDetails: RefundDetails;
  isLoading: boolean;
  expanded: boolean | String;
  index: string;
  onDownloadClick: (
    refundDetails: RefundDetails,
    { type, numeroPolicy }: DocumentParams,
  ) => void;
  loading: boolean;
  downloadError: string;
  hasDecompte?: boolean;
}

const ValidatedClaim = ({
  refund,
  refundDetails,
  expanded,
  index,
  isLoading,
  loading,
  onDownloadClick,
  downloadError,
  hasDecompte: _hasDecompte,
  ...props
}: ValidatedClaimType) => {
  const [hasDecompte, setHasDecompte] = React.useState(_hasDecompte);

  const { formatMessage } = useIntl();

  React.useEffect(() => {
    if (expanded === index) {
      getDecompOrganismesApi()
        .then((res) => {
          setHasDecompte(
            !isEmpty(
              res?.data?.data?.find(
                /* istanbul ignore next */ (d: any) =>
                  d.NUM_POLICE === refund.numeroPolicy,
              ),
            ),
          );
        })
        .catch((err) => {});
    }
  }, [expanded]);

  return (
    <>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box width="100%">
          <Grid container justify="space-between">
            <Grid item xs={12} sm={3}>
              <Grid item>
                <StyledCaption>
                  {translate(get(messages, 'folderNumber'), props)}
                </StyledCaption>
              </Grid>
              <Grid item>
                <Box marginBottom={0}>
                  <StyledShortBody>
                    {refund.numeroApplication +
                      '' +
                      refund.maladyDeclarationSuffix}
                  </StyledShortBody>
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={6} sm>
              <Grid container direction="column">
                <Grid item>
                  <StyledCaption>
                    {translate(get(messages, 'Beneficiary'), props)}
                  </StyledCaption>
                </Grid>
                <Grid item>
                  <ShortBody>{refund.beneficiary}</ShortBody>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} sm>
              <Grid container direction="column">
                <Grid item>
                  <StyledCaption>
                    {translate(get(messages, 'status'), props)}
                  </StyledCaption>
                </Grid>
                <Grid item>
                  <Box marginBottom={0}>
                    <StatusChip
                      status={'success'}
                      label={translate(get(messages, 'statusPaid'), props)}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </AccordionSummary>
      {expanded &&
        index === expanded &&
        (isLoading ? (
          <Grid
            container
            justify="center"
            style={{ marginTop: 40, marginBottom: 40 }}
          >
            <CircularProgress color="inherit" size={20} />
          </Grid>
        ) : (
          <StyledAccordionDetails>
            <Box width="100%">
              <Grid container justify="space-between">
                <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'costs'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <ShortBody>
                        {refundDetails.fraisEngagement + ' DH'}
                      </ShortBody>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'totalCosts'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <ShortBody weight="bold">
                        {refundDetails.montantRegle + ' DH'}
                      </ShortBody>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'lossDate'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <ShortBody>{refund.dateOccu}</ShortBody>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'regulationDate'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <ShortBody>{refundDetails.dateEvenement}</ShortBody>
                    </Grid>
                  </Grid>
                </Grid>
                {/* <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'claimNumber'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <Grid item>
                        <ShortBody>{refundDetails.numSinistre}</ShortBody>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid> */}
              </Grid>
              <Grid container justify="space-between">
                <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'regulationMode'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <Grid item>
                        <ShortBody>
                          {translate(
                            get(
                              messages,
                              refundDetails.modeReglement as string,
                            ),
                            props,
                          )}
                        </ShortBody>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {refundDetails.modeReglement !== 'C' && (
                  <Grid item xs={6} sm>
                    <Grid container direction="column">
                      <Grid item>
                        <StyledCaption>
                          {translate(
                            get(
                              messages,
                              refundDetails.modeReglement === 'V'
                                ? 'rib'
                                : 'adressMandat',
                            ),
                            props,
                          )}
                        </StyledCaption>
                      </Grid>
                      <Grid item>
                        <Grid item>
                          <ShortBody>
                            {refundDetails.modeReglement === 'V'
                              ? refundDetails.rib
                              : refundDetails.adresse}
                          </ShortBody>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
              {hasDecompte && (
                <FeatureToggleHOC feature={FEATURES.DECOMPTE}>
                  <Grid container justify="space-between">
                    <ClaimButton
                      onClick={() => {
                        onDownloadClick(refundDetails, {
                          type: SINISTER_DOCUMENT_TYPES.DECOMPTE,
                          numeroPolicy: refund.numeroPolicy,
                        });
                      }}
                      loading={loading}
                      buttonTitle="amc.suivi.refunds.decompte.button"
                      title={formatMessage(messages.downloadFileTitle)}
                      icon={
                        <img
                          alt="downloadIcon"
                          src={AssuranceIcon['downloadIcon']}
                        />
                      }
                    />

                    <Grid item xs={6} sm></Grid>
                    <Grid item xs={6} sm></Grid>
                  </Grid>
                </FeatureToggleHOC>
              )}
              {downloadError && (
                <ShortBody color="red">{downloadError}</ShortBody>
              )}
              {refundDetails.modeReglement === 'V' && (
                <ShortBody style={{ fontStyle: 'italic' }}>
                  {translate(messages.wireNotice, props)}
                </ShortBody>
              )}
            </Box>
          </StyledAccordionDetails>
        ))}
    </>
  );
};

ValidatedClaim.defaultProps = {
  hasDecompte: false,
};

export default injectIntl(ValidatedClaim);
